import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { methods } from "../../../constants";
import { formatValue, getGniGroupCode } from "../../../utilities";
import { orderByValues } from "../../../data/data";
import styleConstants from "../../../styleConstants";
import StackedColumnChart from "../../chart/StackedColumnChart";

const MethodMixChart = props => {
  const data = props.data;

  const categories = ["2020", "2025", "2030"];

  return (
    <div>
      <StackedColumnChart
        ref={props.innerRef}
        height={styleConstants.stackedBarHeight}
        reference="5.5"
        title="Method Mix in 2020, 2025, and 2030"
        subtitle={props.database.areas[props.areaId].area}
        categories={categories}
        series={methods.map(method => ({
          name: method,
          color: styleConstants.categoryColors.methodColors[method],
          data: orderByValues(
            data.filter(datum => datum.method === method),
            categories,
            "year"
          ).map(datum => datum.value)
        }))}
        reversedLegend={true}
        legendPosition={props.legendPosition}
        absolute={props.absolute}
        tooltipFormatter={function() {
          const gniGroup = getGniGroupCode(
            props.database.areas[props.areaId].area
          );

          return `${this.series.name} Costs in ${gniGroup}, ${
            this.key
          }: <strong>${formatValue(
            this.y
          )}</strong><br />Share of ${gniGroup} Costs, ${
            this.key
          }: <strong>${formatValue(this.percentage / 100, true)}</strong>`;
        }}
      />
    </div>
  );
};

MethodMixChart.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  areaId: PropTypes.number.isRequired,
  legendPosition: PropTypes.string,
  absolute: PropTypes.bool
};

export default memo(
  React.forwardRef((props, ref) => <MethodMixChart innerRef={ref} {...props} />)
);
